module.exports = "\t<div id=\"songSocialInfoWrapper\">\n<%= socialInfoText %>\n\t\t\t\t\t</div>"